import { render, staticRenderFns } from "./EditGalleryMain.vue?vue&type=template&id=9f2c154e&scoped=true&"
import script from "./EditGalleryMain.vue?vue&type=script&lang=js&"
export * from "./EditGalleryMain.vue?vue&type=script&lang=js&"
import style0 from "./EditGalleryMain.vue?vue&type=style&index=0&id=9f2c154e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2c154e",
  null
  
)

export default component.exports